import { AccessStatusQuery } from '../api'

export type ChannelGateInput = {
  /**
   * Спрашивать ли бэк вообще. Гейт имеет смысл только для вошедшего пользователя:
   * ручка авторизованная, а новенькая в онбординге и так внутри льготного периода.
   */
  isEnabled: boolean
}

export type ChannelGate = {
  /** true — доступ закрыт, приложение обязано увести на экран подписки. */
  isBlocked: boolean
}

/**
 * Фоновый статус доступа для роутера.
 *
 * Гейт закрывается ТОЛЬКО по явному «нет» от бэка. Пока запрос идёт, упал или отключён —
 * приложение работает как обычно: заблокировать человека из-за упавшей сети или выключенных
 * моков было бы хуже, чем пропустить неподписанного (бэк всё равно спросит снова через минуту).
 */
export function useChannelGate({ isEnabled }: ChannelGateInput): ChannelGate {
  const { data } = AccessStatusQuery.useQuery(undefined, { enabled: isEnabled })

  return { isBlocked: isEnabled && data?.isAllowed === false }
}
